import { useIntl } from 'react-intl';

import { currentPlanDisplayMessages } from '../../settings/billing/hooks/current-plan-display.messages';
import { useCurrentPlanDisplay } from '../../settings/billing/hooks/useCurrentPlanDisplay';

export type ComplimentaryTrialEndedPlanNames = {
  currentPlanName: string;
  targetPlanName: string;
};

export function useComplimentaryTrialEndedPlanNames({
  isHeidi2OptInEnabled,
}: {
  isHeidi2OptInEnabled: boolean;
}): ComplimentaryTrialEndedPlanNames | null {
  const intl = useIntl();
  const { planName, currentPaidTier, isBillingInfoFetched } = useCurrentPlanDisplay({
    isHeidi2OptInEnabled,
  });

  if (!isBillingInfoFetched || currentPaidTier == null) return null;

  return {
    currentPlanName: planName,
    targetPlanName: intl.formatMessage(currentPlanDisplayMessages.clinicianMaxPlanName),
  };
}
